const defaultApiHost = 'https://backend.doski.bar'

export const API_HOST = process.env.REACT_APP_API_HOST || defaultApiHost
export const API_URL = API_HOST + '/api'
export const SETTINGS_API_URL = API_URL + '/settings'
export const SAVED_REST_ID_KEY = 'selected_restaurant_id'
